<template>
  <div>
    <b-table :items="items"></b-table>
  </div>
</template>

<script>
export default {
  name: "AlertsTabe",
  data() {
    return {
      items: []
    };
  },
  mounted() {
    // // console.log("this.all alert", this.allAlerts);
    // this.allAlerts.srch_tpi_assos.map((aa, index)=>{
    //   // console.log("aa", aa.srch_asso_rdc_indivi_alrt[0].id)
    // })
    // let counts = {};
    this.allAlerts.srch_tpi_assos.map(alert => {
      // // console.log("alert", alert.srch_asso_rdc_indivi_alrt)
      alert.srch_asso_rdc_indivi_alrt.forEach(x => {
        //  // console.log("x", x)
        // counts["Aler Id"] = x.id
        this.items.push({
          alertId: x.id,
          name: x.ent_name,
          alert: x.ent_src_name,
          status: x.rpt_status
        });
      });
    });
    // // console.log("counts", this.items);

    // this.uniqueCategories = Object.entries(counts);
    // const array1 = this.allAlerts.srch_tpi_assos[0];
    // const array2 = this.allAlerts.srch_tpi_assos[1];
    // const array3 = array1.concat(array2);
    // // console.log("this.all alert", array3);
  },
  props: {
    allAlerts: Object
  }
};
</script>